// NOTE: We only support `Meter` & `Foot` in the UI.
export enum Unit {
  Meter = 'M',
  Foot = 'FT',
  // Millimeter = 'MM',
  // Centimeter = 'CM',
  // Kilometer = 'KM',
  // Inch = 'IN',
  // Yard = 'YD',
  // Mile = 'MIL',
}

export enum MLEnum {
  'veinnet' = 'Vein Net',
  'roqenet' = 'RoQE Net',
  'percentageReport' = 'Dominant Color',
  'percentageReportLight' = 'percentageReportLight',
  'munsellReport' = 'Munsell Report',
  'veinFrequency' = 'Vein Frequency',
  'fractureFrequency' = 'Fracture Frequency',
  'rqd' = 'RQD',
  'textureReport' = 'Texture Report',
  'fcnet' = 'FC-Net',
  'veins' = 'Veins',
}

/**
 * The type of log used to determine the type of chart available
 */
export enum LogType {
  qual = 'qualitative',
  quant = 'quantitative',
  default = 'qualitative',
}

/**
 * Required fields for Logs API Data Item
 */
export enum LogsApiSystemColumns {
  drillholeId = 'drillhole_id',
  fromDepth = 'depth_from',
  toDepth = 'depth_to',
  createdAt = 'created_at',
  createdBy = 'created_by',
  updatedAt = 'updated_at',
  updatedBy = 'updated_by',
  logId = 'log_id',
  _id = '_id',
  pointDataOnly = 'pointDataOnly',
}

export enum KnownFileNamePatterns {
  als = '^(.*\\/)*(?<dhid>.*?)_(?<boxNo>.*?)_(?<fromDepth>.*)-(?<toDepth>.*)\\.(jpeg|JPEG|jpg|JPG|png|PNG)$',
  terracore = '^(.*\\/)*RGB_Image__RGB__(?<dhid>.*?)_(?<boxNo>.*)@(?<fromDepth>.*?)_(?<toDepth>.*)\\.(jpeg|JPEG|jpg|JPG|png|PNG)$',
  imago = '^(.*\\/)*(?<dhid>.*)_(?<fromDepth>\\d+\\.?\\d+)_(?<toDepth>\\d+\\.?\\d+)_\\w+\\.(jpeg|JPEG|jpg|JPG|png|PNG)$',
  default = '^(.*\\/)*(?<dhid>.*?)_(?<boxNo>.*?)_(?<fromDepth>.*)-(?<toDepth>.*)\\.(jpeg|JPEG|jpg|JPG|png|PNG)$',
}

export enum ImageUploadColumnHeaders {
  image = 'image',
  safename = 'safename',
  dhid = 'dhid',
  box = 'boxNo',
  fromDepth = 'fromDepth',
  toDepth = 'toDepth',
  interval = 'interval',
  status = 'error',
  imageType = 'imageType',
  imageTypeKey = 'imageTypeKey',
}

export enum DataGridCellClass {
  invalid = 'invalid',
  warning = 'warning',
  default = '',
}

export enum ValidStatus {
  todo = 'todo',
  drillholeProgress = 'drillholeProgress',
  drillholeDone = 'drillholeDone',
  uploading = 'uploading',
  done = 'done',
  error = 'error',
}

export enum LogDataStructure {
  pointData = 'POINT_DATA',
  nonSpatialData = 'NON_SPATIAL_DATA',
  intervalData = 'INTERVAL_DATA',
}

export enum RegisteredImageType {
  core = 'core',
  atv = 'atv',
  otv = 'otv',
  wet = 'wet',
  dry = 'dry',
  hs = 'hs',
  rc = 'rc',
  default = 'core',
}

// degrees to rotate clockwise
export enum Rotation {
  deg0 = 0, // no rotation
  deg90 = 90,
  deg180 = 180,
  deg270 = 270,
}

export enum FlipDirection {
  vertical = 'vertical',
  horizontal = 'horizontal',
}

export enum ChartType {
  categorical = 'categorical',
  numerical = 'numerical',
  image = 'image',
  polygon = 'polygon',
}

export enum CleanImageCoreType {
  multiple = 'multiple',
  single = 'single',
}

export enum JobStatus {
  done = 'done',
  inProgress = 'in-progress',
  requested = 'requested',
  todo = 'todo',
}

export enum OutputJobColumns {
  prediction = 'prediction',
  smoothing = 'Predicted_Smoothed',
}

export enum TargetFeatureTypes {
  categorical = 'categorical',
  numerical = 'numerical',
}

export enum ModelTaskTypes {
  classification = 'classification',
  regression = 'regression',
}

// Valid esimator options for training classification models
export enum ClassificationModelEstimators {
  adaBoost = 'ada',
  catBoost = 'catboost',
  decisionTree = 'dt',
  extraTrees = 'et',
  gaussianProcess = 'gpc',
  gradientBoosting = 'gbc',
  kNeighbors = 'knn',
  lda = 'lda',
  lightGBM = 'lightgbm',
  logisticRegression = 'lr',
  mlp = 'mlp',
  naiveBayes = 'nb',
  qda = 'qda',
  randomForest = 'rf',
  rbfSvm = 'rbfsvm',
  ridge = 'ridge',
  svm = 'svm',
  xgBoost = 'xgboost',
}

// Valid esimator options for training regression models
export enum RegressionModelEstimators {
  adaBoost = 'ada',
  ard = 'ard',
  bayesianRidge = 'br',
  catBoost = 'catboost',
  decisionTree = 'dt',
  elasticNet = 'en',
  extraTrees = 'et',
  gradientBoosting = 'gbr',
  huber = 'huber',
  kNeighbors = 'knn',
  kernelRidge = 'kr',
  lasso = 'lasso',
  lassoLeastAngle = 'llar',
  leastAngleRegression = 'lar',
  lightGBM = 'lightgbm',
  linearRegression = 'lr',
  mlp = 'mlp',
  orthogonalMatchingPursuit = 'omp',
  passiveAggressive = 'par',
  randomForest = 'rf',
  ransac = 'ransac',
  ridge = 'ridge',
  supportVectorRegression = 'svm',
  theilSen = 'tr',
  xgBoost = 'xgboost',
}

export enum ResponseCode {
  success = 200,
  badRequest = 400,
  notFound = 404,
  serverError = 500,
}

/**
 * @default interval
 */
export enum StructureDataTypes {
  'interval' = 'interval',
  'point' = 'point',
}

/**
 * @default simple
 */
export enum MergeType {
  'weighted' = 'weighted',
  'simple' = 'simple',
}

/**
 * @default multihot
 */
export enum CategoricalEncoding {
  'multihot' = 'multihot',
  'nearest' = 'nearest',
  'majority' = 'majority',
  'weighted' = 'weighted',
}

/**
 * @default mean
 */
export enum NumericEncoding {
  'mean' = 'mean',
  'sum' = 'sum',
  'weighted_average' = 'weighted_average',
  'meanstd' = 'meanstd', // Standard deviation
}

export enum ModalIds {
  'merge-types-quantitative' = 'merge-types-quantitative',
  'merge-types-qualitative' = 'merge-types-qualitative',
  'interval-depth-column' = 'interval-depth-column',
  'drillhole-column' = 'drillhole-column',
  'interval-from-column' = 'interval-from-column',
  'interval-to-column' = 'interval-to-column',
  'target-resolution-table' = 'target-resolution-table',
  'layer-tables' = 'layer-tables',
}

export enum Severities {
  'success' = 'success',
  'info' = 'info',
  'warning' = 'warning',
  'error' = 'error',
}

export enum VisualizerDataSourceTypes {
  log = 'log',
  image = 'image',
  file = 'file',
  shape = 'shape',
}

export enum LogStatus {
  open = 'open',
  archived = 'archived',
  locked = 'locked',
  closed = 'closed',
}

export enum SmoothingDataSourceType {
  s3 = 's3',
  logs = 'logs',
  local = 'local',
}

export enum JobArchiveAction {
  Archive = 'archive',
  Unarchive = 'unarchive',
}

export enum ProjectType {
  litholens = 'litholens',
  d3 = 'tessellation',
  smartsuite = 'smartsuite',
  files = 'file-storage',
  common = 'common',
}
